/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import { Button, Modal, CloseButton } from "react-bootstrap";
import "./WnbModalAlert.css";

const WnbModalError = (props) => {
  let showAlert = props.showAlert;
  const onClickModalOk = props.handleOk;
  const title = props.title;
  const message = props.message;
  const okLabel = props.okLabel || "Ok";

  return (
    <Modal
      show={showAlert}
      onHide={onClickModalOk}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title style={{color: "red"}}>{title}</Modal.Title>
        <CloseButton aria-label="Close" onClick={onClickModalOk}/>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className="wnbmodal-btn" onClick={onClickModalOk}>
          {okLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default WnbModalError;